// extracted by mini-css-extract-plugin
var _1 = "assets-js-GalleryPB-components-GalleryResults-GalleryResults-module__galleryPromoRow__sQntJ";
var _2 = "assets-js-GalleryPB-components-GalleryResults-GalleryResults-module__galleryPromoRowImage__Bd0ZS";
var _3 = "assets-js-GalleryPB-components-GalleryResults-GalleryResults-module__galleryResultsWrapper__m1Rd_";
var _4 = "assets-js-GalleryPB-components-GalleryResults-GalleryResults-module__suggestedTemplatesHeader__y9ZIh";
export { _1 as "galleryPromoRow", _2 as "galleryPromoRowImage", _3 as "galleryResultsWrapper", _4 as "suggestedTemplatesHeader" }
